import { setCookie, getCookie } from '../functions';

class Disclaimer {
    constructor() {
        this.disclaimer = document.querySelector('.disclaimer');

        if (!this.disclaimer) return;

        this.init();
    }

    async init() {
        const disclaimerCookie = await getCookie('disclaimerShown');
        if (!disclaimerCookie) {
            this.showDisclaimer();

            setTimeout(() => {
                this.hideDisclaimer();
                setCookie('disclaimerShown', 'true', 365);
            }, 10000);
        }
    }

    showDisclaimer() {
        this.disclaimer.classList.add('is-active');
    }

    hideDisclaimer() {
        this.disclaimer.classList.remove('is-active');
    }
}

document.addEventListener('DOMContentLoaded', () => new Disclaimer());

export default Disclaimer;
